/**
 * Global-child - assets/js
 */

/**
 * Vanilla JS
 */

/**
 * jQuery
 */
jQuery( document ).ready( function( $ ) {

});
